module.exports = __webpack_public_path__ + "static/content_4_1_dont-20bda87f8688152dc0a4c8405dcb1f41.png";